<template lang="pug">
#heatmap_os_pc
  table.table
    tbody
      tr
        th windows
        td {{ windows }} %
      tr
        th mac
        td {{ mac }} %

</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'

export default {
  props: {
    state_name: {
      type: String,
      default: "heatmap"
    },
  },
  data() {
    return {
    }
  },
  computed: {
    windows() {
      return this.$store.state[this.state_name].os_data.windows;
    },
    mac(){
      return this.$store.state[this.state_name].os_data.mac;
    }
  }
}
</script>
